export default __webpack_public_path__ + "static/icon-en-f7867699f0aec7337bbfa26fc28e568d.png";